import palette from "./palette";
import typography from "./typography";
import breakpoints from "./breakpoints";
import spacing from "./spacing";

import ThemeInterface from "types/ThemeInterface";

const theme: ThemeInterface = {
  customTheme: {
    palette,
    typography,
    breakpoints,
    spacing,
    pxToRem: (pixels: number) => `${pixels / 16}rem`,
    loader: "/animations/loader",
  },
  formFields: {
    backgroundColor: "white",
    selected: {
      backgroundColor: "rgb(0, 126, 146)",
    },
  },
};

export default theme;
